import { BrowserRouter, Switch, Route } from "react-router-dom";
// Components
import ChangeEmail from "../views/Change-Email";

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route path={`/home/:token`} component={ChangeEmail} />
    </Switch>
  </BrowserRouter>
);

export default Routes;
